// extracted by mini-css-extract-plugin
module.exports = {"buttons":"Landing_buttons__HX_yd","custom":"Landing_custom__2zdsP","register":"Landing_register__1iK7O","discord":"Landing_discord__2dFpZ"};